import { render } from "./BaseFooterNav.vue?vue&type=template&id=7edfa5ae&scoped=true"
import script from "./BaseFooterNav.vue?vue&type=script&lang=js"
export * from "./BaseFooterNav.vue?vue&type=script&lang=js"

import "./BaseFooterNav.vue?vue&type=style&index=0&id=7edfa5ae&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edfa5ae"]])

export default __exports__